import TechnicalValidationWelcoming from './TechnicalValidationWelcoming.component';

export default TechnicalValidationWelcoming;
